<div *ngIf="parametrosCorrectos;else ParametrosInvalidos">
    <div class="card mt-3 p-2 mb-3" *ngIf="diputado">
        <div class="row m-2 text-center">
            <h2 class="col ">
                <p *ngIf="diputado.NombreDiputado != null" class="mb-0">
                    {{diputado.NombreDiputado}}</p>
            </h2>
        </div>

        <hr>
        <div class=" container ">
            <div class="row">
                <p class="col-12 col-lg-4 " *ngIf="diputado.GrupoParlamentario != null">
                    <b>Grupo Parlamentario: </b>{{diputado.GrupoParlamentario}}
                </p>
                <p class="col-12 col-lg-4 " *ngIf="diputado.EntidadFederativa != null">
                    <b>Entidad Federativa: </b>{{diputado.EntidadFederativa}}
                </p>
                <p class="col-12 col-lg-4 " *ngIf="diputado.DistritoCircuns != null">
                    <b>Distrito / Circunscripción: </b>{{diputado.DistritoCircuns}}
                </p>
                <p class="col-12 col-lg-4 " *ngIf="diputado.TipoEleccion != null">
                    <b>Tipo de elección: </b>{{diputado.TipoEleccion}}
                </p>
            </div>
            <div class="container" *ngIf="pdfCarga == true && !sinDocumento" id="cargandoPDf">
                <div class="items-container mt-5 load">
                    <div class="alert alert-info text-center col-12 mb-5 ">
                        <div class="spinner-border" role="status">
                            <span class="sr-only"></span>
                        </div>
                        <h3>Cargando PDF... </h3>
                    </div>
                </div>
            </div>
            <div class="container" *ngIf="sinDocumento" id="cargandoPDf">
                <div class="items-container mt-5 load">
                    <div class="alert alert-info text-center col-12 mb-5 ">
                        <h3>No se encontró: {{Documento}}</h3>
                    </div>
                </div>
            </div>

            <div [ngClass]="{'d-none': pdfError == true}" *ngIf="Archivo != null">
                <pdf-viewer [src]="Archivo" [zoom]=".7" [contentEditable]="false" [render-text-mode]="0"
                    [original-size]="false" [render-text]="true"
                    (after-load-complete)="lectorPdf = true; pdfCarga = false"
                    (error)="pdfError = true; pdfCarga = false" [render-text-mode]="2" class="pdf mt-2"
                    [ngClass]="{'cargaPDF': lectorPdf == true}" [show-borders]="true"></pdf-viewer>
            </div>
        </div>
    </div>

</div>
<ng-template #ParametrosInvalidos>
    <div class="container">
        <div class="items-container mt-5 load">
            <div class="alert alert-info text-center col-12 mb-5 ">
                <h3>No se encontró Información</h3>
            </div>
        </div>
    </div>
</ng-template>
<mat-dialog-actions>
    <div class="row container justify-content-center mt-3 mb-3">

        <div class="col-md-3 p-1 text-center">
            <button class="btn btn-success btn-block" (click)="onNoClick()">
                Cerrar
            </button>
        </div>
    </div>
</mat-dialog-actions>